module.exports = __webpack_public_path__ + "img/siddhant-pro.4a27f156.jpg";